
import OabatHeader from "@/components/layout/OabatHeader"
import StreamCard from "@/components/livestream/StreamCard"
import breadcrumb from "@/mixins/breadcrumb"
import defaultMeta from "@/mixins/defaultMeta"
import { mdiDeleteOutline } from "@mdi/js"
import { mapGetters } from "vuex"
import OabatTextFieldSearchIcon from "@/components/base/design/OabatTextFieldSearchIcon"
import dates from "@/mixins/dates"

export default {
    meta: {
        searchPage: true,
    },
    components: { OabatTextFieldSearchIcon, OabatHeader, StreamCard },
    mixins: [breadcrumb, defaultMeta, dates],
    data: () => {
        return {
            mdiDeleteOutline,
            search: "",
            generalSearchStorage: "",
        }
    },
    watchQuery: true,
    computed: {
        ...mapGetters("livestream", ["slots", "id"]),

        filteredCards() {
            if (!this.search) {
                return this.slots /** No search */
            } else {
                return this.slots.filter((slot) => {
                    return slot.companies?.some((c) => {
                        /** Letters only normalization used */
                        return c.name
                            .toLowerCase()
                            .normalize("NFD")
                            .replace(/[^A-Z0-9]/gi, "")
                            .includes(
                                this.search
                                    .toLowerCase()
                                    .normalize("NFD")
                                    .replace(/[^A-Z0-9]/gi, "")
                            )
                    })
                })
            }
        },
    },
    mounted() {
        this.$store
            .dispatch("livestream/initialize", this.$route.params.livestream)
            .then(() => {})
        this.generalSearchStorage =
            this.$store.getters["search/selectedCategory"]
        this.$store.commit("search/SET_SELECTED_CATEGORY", "Livestream")
    },
    destroyed() {
        this.$store.commit(
            "search/SET_SELECTED_CATEGORY",
            this.generalSearchStorage
        )
    },
    methods: {
        routeToStream() {
            this.$router.push("/livestream/" + this.$route.params.livestream)
        },
        isLive(slot) {
            return slot.from > new Date() && slot.to < new Date()
        },
    },
    head() {
        return {
            title: "Finde Firmen im Livestream",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        "Erlebe die besten Arbeitgeber deiner Region im Livestream und finde deine Ausbildung.",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content:
                        "Erlebe die besten Firmen/Arbeitgeber deiner Region LIVE.",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        "Erlebe die besten Arbeitgeber deiner Region im Livestream und finde deine Ausbildung.",
                },
            ],
            __dangerouslyDisableSanitizers: ["script"],
            script: [
                {
                    innerHTML:
                        this.location && JSON.stringify(this.getBreadcrumb()),
                    type: "application/ld+json",
                },
            ],
        }
    },
}
